module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td id="bill-'+
((__t=( document_type ))==null?'':__t)+
''+
((__t=( number ))==null?'':__t)+
'">\n  <a class="bill-link" href="#bills/'+
((__t=( id ))==null?'':__t)+
'" oncontextmenu="return false">'+
((__t=( document_type ))==null?'':__t)+
' '+
((__t=( number ))==null?'':__t)+
'</a>\n</td>\n<td class="bill-description">'+
((__t=( caption ))==null?'':_.escape(__t))+
'</td>\n<td class="text-end">'+
((__t=( status_date ))==null?'':_.escape(__t))+
'</td>';
}
return __p;
};
